import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Ace extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - Aim for the Ace! - English Translation v1.3
            SNES - Ace wo Nerae! - エースをねらえ！
          </title>
          <meta
            name="title"
            content="RPGONE Translations - Aim for the Ace! - English Translation v1.3 SNES - Ace wo Nerae! - エースをねらえ！"
          />
          <meta
            name="description"
            content="Ace wo Nerae! Snes English Translation v1.3 - I'm Hiromi Oka, a first year student, at the prestigious Nishi High School. Well, there's an amazing person in our tennis club called Reika Ryuzaki, nicknamed Madam Butterfly, who's a top class tennis player - Aim for the Ace! for the SNES / Super Famicom / Super Nintendo by RPGONE Translations"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                {/*<h3>Aim for the Ace! - English Translation</h3>
            <i><div>エースをねらえ！ - "Ace wo Nerae!"</div></i>*/}
              </span>
              <div className="center-image">
                <img
                  src={require("./img/proj/ace_00001.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00002.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00004.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00012.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00008.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00006.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00010.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/ace_00019.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    Aim for the Ace! - Ace wo Nerae!<br />Original release: 22nd
                    December 1993 on Super Famicom (Snes / Super Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              I'm Hiromi Oka, a first year student, at the prestigious Nishi
              High School. Well, there's an amazing person in our tennis club
              called Reika Ryuzaki, nicknamed "Madam Butterfly", who's a top
              class tennis player. Of course, there are also some amazing
              players in the boy's tennis club like Tohdoh and Ozaki. <br />
              <br />
              I joined the club because I idolized Madam Butterfly, but the
              coach is such a slave driver. He makes us train really hard every
              day. It's so awful. In the midst of all this, the match against
              Minami High has begun...
              <br />
              <br />
              <div className="center-image">
                <a href={require("./img/box/Ace wo Nerae - Box Cover.jpg")}>
                  <img
                    src={require("./img/box/Ace wo Nerae - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./img/box/Ace wo Nerae - Box Back.jpg")}>
                  <img
                    src={require("./img/box/Ace wo Nerae - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Aim for the Ace - English v1.3.zip")}
                download="Aim for the Ace - English v1.3.zip"
              >
                English Translation patch v1.3
              </a>{" "}
              by RPGONE
              <br />
              <br />
              <a href="https://www.romhacking.net/translations/688/">
                Project page on romhacking.net
              </a>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <b>Debug Mode</b>
              <br />
              <br />
              <b>80C52F00</b> - Press "Select & Top-Right" in-game to end the
              current Match and WIN<br />
              <br />
              <b>80C53F00</b> - Press "Select & Top-Left" in-game to end the
              current Match and LOSE
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Ace);



// WEBPACK FOOTER //
// ./src/Ace.js